export type LojaIntegradaCompletionMessages = {
  lojaIntegradaCompletionMessagesText1Part1: string;
  lojaIntegradaCompletionMessagesText1Part2: string;
};

export const lojaIntegradaCompletionMessages: LojaIntegradaCompletionMessages = {
  lojaIntegradaCompletionMessagesText1Part1:
    "A integração com a Loja Integrada foi concluída com sucesso!",
  lojaIntegradaCompletionMessagesText1Part2:
    "Aproveite agora o sistema de vendas da Talk2Buy e continue a se conectar com outras plataformas!",
};
